import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

export class CookiePolicyController implements Controller {
  public pageId = 'CookiePolicy';
  public path = '/:localeName/cookie-policy';
  public routeName = 'cookie-policy';
  public bundles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "cookie-policy-page" */ '../views/cookie-policy-page'),
  );
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub Cookie Policy' }) as Promise<PageData>;
  }
}
